import { JSXElementConstructor, ReactElement } from 'react';
import { Order, Row } from '../types';

export const descComparator = <Key extends keyof any>(
  a: { [key in Key]: unknown },
  b: { [key in Key]: unknown },
  orderBy: any
): number => {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }

  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
};

export const getComparator = <Key extends keyof any>(
  order: Order,
  orderBy: Key
): ((a: { [key in Key]: unknown }, b: { [key in Key]: unknown }) => number) => {
  return order === Order.Desc
    ? (aa, bb) => descComparator(aa, bb, orderBy)
    : (aa, bb) => -descComparator(aa, bb, orderBy);
};

export const stableSort = <T,>(
  array: Row[],
  comparator: (a: T, b: T) => number
): T[] => {
  const stabilizedThis = array.map(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (el, index) => [el, index] as [Row, number]
  );

  stabilizedThis.sort((a, b) => {
    const order = comparator(
      a[0].cells as unknown as T,
      b[0].cells as unknown as T
    );
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  return stabilizedThis.map((el) => el[0] as unknown as T);
};

export const getSortValue = (
  element: ReactElement<any, string | JSXElementConstructor<any>>
): string => element.props['data-sortvalue']?.toUpperCase() || '';
